import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { colors as defaultColors } from '../theme/colors';

export const useTheme = () => {
  const theme = useContext(ThemeContext);

  if (theme && theme.colors) {
    return { colors: theme.colors };
  }
  
  return { colors: defaultColors };
};

export default useTheme;

